import z from "zod";

import { buildPatientInformationSchema } from "features/Session/PatientInformation/PatientInformation.schema";

export const buildSummarizeSchema = (/* t: (key: string, opts?: Record<string, string>) => string */) =>
  buildPatientInformationSchema(/* t */).catchall(z.any());
